import { useMutation } from "@tanstack/react-query";
import {
  Button,
  CircularProgress,
  FormControl,
  GKModal,
  GKTextField,
  Grid2,
} from "components";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  invoiceSeriesData?: any;
  invoiceSeriesRefetch: any;
}

const InvoiceCardModal = (props: Props) => {
  const { id } = useParams();

  const { open, setOpen, invoiceSeriesData, invoiceSeriesRefetch } = props;

  const { mutate, isLoading } = useMutation({
    mutationKey: ["CREATE_BILLING"],
    mutationFn: (data: any) =>
      axiosInstance.patch(`/super_admin/${id}/update_invoice_series/`, data),
    onSuccess: (response) => {
      invoiceSeriesRefetch();
      setOpen(false);
      toast.success(response?.data?.message || "Update Successfully");
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      invoiceSeries: invoiceSeriesData?.invoiceSeries || "",
      invoiceLength: invoiceSeriesData?.invoiceLength || "",
    },
    onSubmit: (values) => {
      mutate(values);
    },
  });

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle={"Edit"}
      width={"400px"}
      footer={
        <Grid2
          container
          size={12}
          justifyContent={"flex-end"}
          alignContent={"center"}
          gap={1}
        >
          <Button variant="lightBg" onClick={() => setOpen(false)}>
            Close
          </Button>
          <Button
            variant="contained"
            onClick={() => formik.handleSubmit()}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={20} /> : "Submit"}
          </Button>
        </Grid2>
      }
    >
      <form onSubmit={formik.handleSubmit}>
        <Grid2 container spacing={2}>
          <Grid2 size={12}>
            <FormControl variant="standard" fullWidth>
              <GKTextField
                type="text"
                inputLabel="Invoice Series"
                onChange={formik?.handleChange}
                value={formik.values.invoiceSeries}
                name="invoiceSeries"
              />
            </FormControl>
          </Grid2>
          <Grid2 size={12}>
            <FormControl variant="standard" fullWidth>
              <GKTextField
                type="text"
                inputLabel="Invoice Length"
                onChange={formik?.handleChange}
                value={formik.values.invoiceLength}
                name="invoiceLength"
              />
            </FormControl>
          </Grid2>
        </Grid2>
      </form>
    </GKModal>
  );
};

export default InvoiceCardModal;
